import { InnerRowValue } from './inner-row-value.model';

export class InnerRow {
  id: string;
  parent: string;
  name: string;
  value: InnerRowValue[] = [];
}
